import React from 'react';
import { IonModal, IonContent } from '@ionic/react';
import Button from '../../../../components/atoms/button';
import { isPlatform } from '@ionic/react';
import './WhatsAppModal.css';

interface WhatsAppModalProps {
  isOpen: boolean;
  onClose: () => void;
  propertyNumber?: string;
  district_Name?: string;
  city_Name?: string;
  parcel_Cod?: string;
  propertyAdvertisements?: any[];
  currentLongitude?: number;
  currentLatitude?: number;
  shareOnWhatsAppFunction: (longitude: number, latitude: number, message: string, isLocation: boolean) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

const WhatsAppModal: React.FC<WhatsAppModalProps> = ({
  isOpen,
  onClose,
  propertyNumber,
  district_Name,
  city_Name,
  parcel_Cod,
  propertyAdvertisements,
  currentLongitude,
  currentLatitude,
  shareOnWhatsAppFunction,
  isLoading,
  setIsLoading
}) => {
  const [whatsUpLocationButton, setWhatsUpLocationButton] = React.useState<string>("primary");
  const [whatsUpAddsButton, setWhatsUpAddsButton] = React.useState<string>("primary");

  const handleLocationShare = async () => {
    setWhatsUpLocationButton("outline");
    setTimeout(() => {
      setWhatsUpLocationButton("primary");
    }, 100);

    setIsLoading(true);
    setTimeout(async () => {
      let message = ` قطعة: ${propertyNumber} | ${district_Name?.replace("حي ", "")} | ${city_Name}`;

      if (isPlatform("mobileweb")) {
        shareOnWhatsAppFunction(currentLongitude || 0, currentLatitude || 0, message, true);
      } else if (isPlatform("android") || isPlatform("ios")) {
        const url = `https://thki.sa/app/${parcel_Cod}`;
        const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(message + "\n" + url)}`;
        window.open(whatsappUrl, "_system");
      } else {
        shareOnWhatsAppFunction(currentLongitude || 0, currentLatitude || 0, message, true);
      }
      setIsLoading(false);
    }, 2500);
  };

  const handleAdvertisementShare = async () => {
    setWhatsUpAddsButton("outline");
    setTimeout(() => {
      setWhatsUpAddsButton("primary");
    }, 100);

    setIsLoading(true);
    setTimeout(async () => {
      let message = ` قطعة: ${propertyNumber} | ${district_Name?.replace("حي ", "")} | ${city_Name}`;

      if (isPlatform("android") || isPlatform("ios")) {
        const url = `https://thki.sa/app/d/${parcel_Cod}`;
        const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(message + "\n" + url)}`;
        window.open(whatsappUrl, "_system");
      } else {
        shareOnWhatsAppFunction(currentLongitude || 0, currentLatitude || 0, message, false);
      }
      setIsLoading(false);
    }, 2500);
  };

  return (
    <IonModal
      isOpen={isOpen}
      initialBreakpoint={0.4}
      breakpoints={[1, 1, 1, 1]}
      onWillDismiss={onClose}
      trigger="open-custom-dialog"
    >
      <IonContent>
        <div className="whatsapp-modal-content w-full h-full pt-4 flex flex-col justify-start items-center">
          <p className="font-bold text-primaryColor100 text-2xl">
            من فضلك اختر نوع الإرسال
          </p>

          <div className="w-full mt-4">
            <Button
              theme={whatsUpLocationButton}
              text={"إرسال موقع القطعة"}
              size={"big"}
              onClick={handleLocationShare}
            />
          </div>

          {propertyAdvertisements && propertyAdvertisements.length > 0 ? (
            <div className="w-full mt-4">
              <Button
                theme={whatsUpAddsButton}
                text={"إرسال الاعلان بداخل القطعة"}
                size={"big"}
                onClick={handleAdvertisementShare}
              />
            </div>
          ) : null}

          <div className="w-full mt-4">
            <Button
              theme={"danger"}
              text={"إغلاق"}
              size={"big"}
              onClick={onClose}
            />
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default WhatsAppModal;
